import { useRootStore } from 'models/RootStore';
import UserStore from 'models/UserStore';

const useUserStore = (): UserStore => useRootStore().userStore;

export { useUserStore };
